import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withTemplates } from 'hocs';
import { notificationActions } from '../../../../../components/notifications/actions/notification';
import { TemplatesAddModalView, } from '../../../components/sections/templates/components/templatesAddModal';
import { validate } from '../../../components/sections/templates/components/templatesAddModal/utils';
const mapDispatchToProps = (dispatch) => ({
    notificationAdd: (payload) => dispatch(notificationActions.notificationAdd(payload)),
});
const TemplatesAddModalForm = reduxForm({
    form: 'TemplatesAddModalForm',
    enableReinitialize: true,
    validate,
})(TemplatesAddModalView);
const TemplatesAddModal = withTemplates(TemplatesAddModalForm);
export default connect(undefined, mapDispatchToProps)(TemplatesAddModal);
